<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-title>{{'EMAIL_PRINTING' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<div class="ion-padding custom-scroll-content"  [attr.aria-label]="newMessage">
  <div class="email-message" [innerHTML]="newMessage"></div>
</div>